/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Cc_Position_Center_RightInputs */

const en_shortcut_keys_name_cc_position_center_right = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Center_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position Center Right`)
};

const fr_shortcut_keys_name_cc_position_center_right = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Center_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positionner au centre droit`)
};

const de_shortcut_keys_name_cc_position_center_right = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Center_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position Mitte rechts`)
};

const it_shortcut_keys_name_cc_position_center_right = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Center_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione Centro Destra`)
};

const ru_shortcut_keys_name_cc_position_center_right = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Center_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Позиция: Центр справа`)
};

const es_shortcut_keys_name_cc_position_center_right = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Center_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posición Centro Derecha`)
};

const zh_cn2_shortcut_keys_name_cc_position_center_right = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Center_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置中心右侧`)
};

const ja_shortcut_keys_name_cc_position_center_right = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Center_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中央右の位置`)
};

const hi_shortcut_keys_name_cc_position_center_right = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Center_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थिति केंद्र दाईं ओर`)
};

const pt_pt2_shortcut_keys_name_cc_position_center_right = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Center_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posição Central Direita`)
};

/**
* | output |
* | --- |
* | "Position Center Right" |
*
* @param {Shortcut_Keys_Name_Cc_Position_Center_RightInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_cc_position_center_right = /** @type {((inputs?: Shortcut_Keys_Name_Cc_Position_Center_RightInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Cc_Position_Center_RightInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_cc_position_center_right(inputs)
	if (locale === "de") return de_shortcut_keys_name_cc_position_center_right(inputs)
	if (locale === "it") return it_shortcut_keys_name_cc_position_center_right(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_cc_position_center_right(inputs)
	if (locale === "es") return es_shortcut_keys_name_cc_position_center_right(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_cc_position_center_right(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_cc_position_center_right(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_cc_position_center_right(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_cc_position_center_right(inputs)
	return en_shortcut_keys_name_cc_position_center_right(inputs)
});